import { render, staticRenderFns } from "./Periodo.vue?vue&type=template&id=36eae942&scoped=true&"
import script from "./Periodo.vue?vue&type=script&lang=js&"
export * from "./Periodo.vue?vue&type=script&lang=js&"
import style0 from "./Periodo.vue?vue&type=style&index=0&id=36eae942&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36eae942",
  null
  
)

export default component.exports